import { useNavigate, useLocation } from "react-router-dom";

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const pathParts = location.pathname.split("/");
  const patientId =
    pathParts[1] === "patients" && pathParts[2]
      ? pathParts[2]
      : null;

  const isHome = location.pathname === "/";
  const isPatientPage = pathParts[1] === "patients" && patientId;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg z-50">
      <div className="flex justify-around h-14">

        {/* Home */}
        <button
          onClick={() => navigate("/")}
          className={`flex-1 flex flex-col items-center justify-center text-sm ${
            isHome ? "text-blue-600 font-semibold" : "text-gray-600"
          }`}
        >
          🏠
          <span className="text-xs">Home</span>
        </button>

        {/* Add Patient */}
        <button
          onClick={() => navigate("/patients/new")}
          className="flex-1 flex flex-col items-center justify-center text-sm text-gray-600"
        >
          ➕
          <span className="text-xs">Patient</span>
        </button>

        {/* Add Visit (only on patient page) */}
        {isPatientPage && (
          <button
            onClick={() =>
              navigate(`/patients/${patientId}/visit/new`)
            }
            className="flex-1 flex flex-col items-center justify-center text-sm text-blue-600 font-semibold"
          >
            🩺
            <span className="text-xs">Visit</span>
          </button>
        )}
      </div>
    </div>
  );
}

export default BottomNav;
